import { Controller } from '@hotwired/stimulus'
import { useResize } from 'stimulus-use'
import { useEventListener } from '~/controllers/concerns/use_event_listener'

const minimumHeight = 10

export default class extends Controller {
  static targets = ['iframe']

  connect() {
    // All behaviors use the same `resize` method
    useResize(this, {
      dispatchEvent: false,
      element: this.iframeTarget.contentDocument.body
    })
    useEventListener(this, {
      event: ['load', 'turbo:load', 'turbo:frame-load'],
      element: this.iframeTarget.contentWindow,
      listener: 'resize' // Both behaviors use the same method
    })
  }

  resize() {
    const height = Math.max(this.iframeTarget.contentDocument.body.scrollHeight, minimumHeight)
    this.iframeTarget.style.height = `${height}px`
  }
}
